import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";

const PATH = "account-user-groups";

@Injectable({
  providedIn: "root",
})
export class AccountUserGroupsHandlerService {
  constructor(private ApiService: ApiService) {}

  getAccountUserGroup(accountID: number, groudID: number) {
    return this.ApiService.get(`${PATH}/${accountID}/${groudID}`);
  }

  getAccountUserGroups(
    accountID: number,
    queryParams?: {
      page?: number;
      perPage?: number;
    },
  ) {
    return this.ApiService.get(`${PATH}/${accountID}`, { params: queryParams });
  }

  deleteAccountUserGroup(masterAccountID: number, group: any) {
    return this.ApiService.delete(`${PATH}/${masterAccountID}/${group.id}`);
  }

  postAccountUserGroup(masterAccountID: number, group: any) {
    return this.ApiService.post(`${PATH}/${masterAccountID}`, group);
  }

  putAccountUserGroup(masterAccountID: number, group: any) {
    return this.ApiService.put(`${PATH}/${masterAccountID}/${group.id}`, group);
  }
}
